



























import { Vue, Prop, Component } from "vue-property-decorator";
@Component({
  components: {}
})
export default class LoginEntrance extends Vue {
  @Prop({ default: "follow" })
  private type?: string;

  get text() {
    switch (this.type) {
      case "follow":
        return "followers";
      case "goldenFollow":
        return "golden followers";
      case "like":
        return "likes";
      case "comment":
        return "comments";
      case "view":
        return "views";
      default:
        return "";
    }
  }

  get beforeText() {
      switch (this.type) {
          case "follow":
          case "goldenFollow":
              return "to get ";
          case "like":
          case "comment":
          case "view":
              return "to choose posts to get ";
          default:
              return "";
      }
  }
}
